<template>
	<router-view />
</template>

<script>
import { SET_EHMOBILE } from "@/store/modules/autenticacao/types";

export default {
  name: 'app',
  data() {
    return {
    };
  },
  mounted() {
  },  
  beforeDestroy() {  
    
  },
  methods: {
    ajustarViewportTablet() {      
      const ehMobile = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
			this.$store.dispatch(SET_EHMOBILE, ehMobile);
    },
  },
  computed: {
  },
  watch: {
    '$route.name'() {
			this.ajustarViewportTablet();
		},
  }
}
</script>
